import React, { useState } from 'react';
import InfoBanner from '../../components/blocks/InfoBanner';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import HideFiltersButton from '../../components/blocks/filters/mePosFilters/HideFiltersButton';
import MePosSaleTitle from '../../components/blocks/title/MePosSaleTitle';
import MePosSaleFilters from '../../components/blocks/filters/MePosSaleFilters';
import SalesDataContainer from '../../components/blocks/sales/SalesDataContainer';

const MePosSalePage = () => {
  const {t} = useTranslation();
  const [showFilters, setShowFilters] = useState(true);

  return (
    <div className="me-pos">
      <Row className="d-flex flex mt-3 justify-content-center main-view-pos">
        <InfoBanner>
          {t('salesStatistics.On this page you can view sales statistics for the selected period of time. You can choose one of 3 types of statistics.')}
        </InfoBanner>
        <Row className="justify-content-between mb-3 mb-md-5">
          <Col md={7} className="mb-4 mb-md-0 ps-0">
            <MePosSaleTitle />
          </Col>
          <Col md={5} xl={4} xxl={3} className="px-0 d-flex align-items-center">
            <Row className="flex-grow-1">
              <Col xs={12} sm={6} lg={7} xl={6} className="ms-auto">
                <HideFiltersButton
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {showFilters && <MePosSaleFilters />}
        <SalesDataContainer />
      </Row>
    </div>
  );
};

export default MePosSalePage;